import type { TransformState, TransitionConfig } from './types'

export const DEFAULT_TRANSFORM: TransformState = {
  x: 0,
  y: 0,
  scale: 1,
  rotate: 0,
  skewX: 0,
  skewY: 0,
  opacity: 1,
}

export const DEFAULT_TRANSITION: TransitionConfig = {
  type: 'spring',
  spring: { stiffness: 100, damping: 10, mass: 1, bounce: 0.25 },
  tween: { duration: 0.5, ease: 'easeInOut' },
  inertia: { velocity: 200, power: 0.8, min: -300, max: 300 },
}

export interface SliderRange {
  min: number
  max: number
  step: number
  unit?: string
}

export const TRANSFORM_RANGES: Record<keyof TransformState, SliderRange> = {
  x:       { min: -300, max: 300, step: 1, unit: 'px' },
  y:       { min: -300, max: 300, step: 1, unit: 'px' },
  scale:   { min: 0.1,  max: 3,   step: 0.05, unit: 'x' },
  rotate:  { min: -360, max: 360, step: 1, unit: 'deg' },
  skewX:   { min: -45,  max: 45,  step: 1, unit: 'deg' },
  skewY:   { min: -45,  max: 45,  step: 1, unit: 'deg' },
  opacity: { min: 0,    max: 1,   step: 0.01 },
}

export const SPRING_RANGES = {
  stiffness: { min: 1,   max: 1000, step: 1 },
  damping:   { min: 0,   max: 100,  step: 1 },
  mass:      { min: 0.1, max: 10,   step: 0.1 },
  bounce:    { min: 0,   max: 1,    step: 0.05 },
}

export const TWEEN_RANGES = {
  duration: { min: 0.1, max: 5, step: 0.1, unit: 's' },
}

export const INERTIA_RANGES = {
  velocity: { min: -1000, max: 1000, step: 10 },
  power:    { min: 0.1,   max: 2,    step: 0.1 },
  min:      { min: -500,  max: 0,    step: 10 },
  max:      { min: 0,     max: 500,  step: 10 },
}

export const EASING_PRESETS = [
  'linear',
  'easeIn',
  'easeOut',
  'easeInOut',
  'circIn',
  'circOut',
  'circInOut',
  'backIn',
  'backOut',
  'backInOut',
] as const
